import axios from "axios";
import { IAuthorization } from "../models/authorization";
import { ICertificate } from "../models/certificate";
import { getTodayDate, IPaginationWrapper } from "../models/common";
import { IIDDataSetFilter } from "../models/crewMember";

export const createNewCertificate = async (
    certificate: ICertificate,
    attachment1: File | undefined = undefined,
    attachment2: File | undefined = undefined
) => {
    const formData = new FormData();
    const withTs = { ...certificate, ts: Date.now() };
    formData.append("certificate", JSON.stringify(withTs));
    attachment1 && formData.append("attachment1", attachment1, attachment1.name);
    attachment2 && formData.append("attachment2", attachment2, attachment2.name);
    return axios.post("/api/certificates", formData);
};

export const updateCertificate = async (
    certificate: ICertificate,
    attachment1: File | undefined = undefined,
    attachment2: File | undefined = undefined
) => {
    const formData = new FormData();
    formData.append("certificate", JSON.stringify(certificate));
    attachment1 && formData.append("attachment1", attachment1, attachment1.name);
    attachment2 && formData.append("attachment2", attachment2, attachment2.name);
    return axios.patch(`/api/certificates/${certificate.guid}/update`, formData);
};

export const addAuthorization = async (auth: IAuthorization) => {
    return axios.post(`/api/certificates/${auth.linkedQualificationID}/auth`, auth);
};

export const modifyCertificate = async (dto: Partial<ICertificate>) => {
    return axios.patch(`/api/certificates/${dto.qualificationID}/modify`, dto);
};

export const renewCertificate = async (qualId: string, dto: ICertificate) => {
    return axios.patch(`/api/certificates/${qualId}/renew`, dto);
};

export const sendCertificateWithdrawalRequest = async (qualId: string, reason: string) => {
    return axios.patch(`/api/certificates/${qualId}/withdraw`, null, {
        params: { reason: reason },
    });
};

export const downloadUnionCertificate = async (qualId: string, filename: string) => {
    const res = await axios.get(`/api/certificates/${qualId}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};

export const printCertificate = async (qualId: string) => {
    return axios.get(`/api/certificates/${qualId}/print`);
};

export const getIcsAplicationsAsync = async (filter: IIDDataSetFilter) => {
    const res = await axios.get(`/api/certificates/allics`, { params: filter });
    return res.data as IPaginationWrapper;
};

export const downloadIcsAplicationsAsCsv = async (data: IIDDataSetFilter) => {
    const res = await axios.post(`/api/certificates/csvdownload`, data, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    const todayDate = `${getTodayDate().day}/${getTodayDate().month}/${getTodayDate().year}`;
    link.setAttribute("download", `IcsAplications_${todayDate}.csv`);
    document.body.appendChild(link);
    link.click();
};

export const deleteAttachment = async (guid: string, num: 1 | 2) => {
    return axios.delete(`/api/certificates/attachments/${guid}/${num}`);
};

export const getSearchableIcsProps = async () => {
    const res = await axios.get(`/api/certificates/searchable`);
    return res.data;
};

export const getSearchableIcsUserProps = async () => {
    const res = await axios.get(`/api/certificates/searchableUser`);
    return res.data;
};
